import axios from "axios";
import React, { useEffect, useState } from "react";
import "./profiledata.scss";

function Profiledata() {
  const id = JSON.parse(window.localStorage.getItem("logId"));
  const [data, setData] = useState(false);

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    setData(result.data.data[0]);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className="profileData">
      <table>
        <tbody>
          <tr>
            <td>Name</td>
            <td>:</td>
            <td>{data ? data.name : ""}</td>
          </tr>
          <tr>
            <td>Gender</td>
            <td>:</td>
            <td>{data ? data.gender : ""}</td>
          </tr>
          <tr>
            <td>Phone</td>
            <td>:</td>
            <td>{data ? data.phone : ""}</td>
          </tr>
          <tr>
            <td>Address</td>
            <td>:</td>
            <td>{data ? data.address : ""}</td>
          </tr>
          <tr>
            <td>Date of Birth</td>
            <td>:</td>
            <td>{data ? data.birthday : ""}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>:</td>
            <td>{data ? data.email : ""}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default Profiledata;
